<script lang="ts">
	import ProfileNav from './../ecom/ProfileNav.svelte';
	/**
	 * A component for ensuring an unified maximal content width for all contents
	 * Typicall this component should wrap any section and content of the page.
	 *
	 * <Section>
	 * 	... content here ...
	 * </Section>
	 *
	 *
	 * Typically you should try to avoid using the "full" type since you would have to manually ensure the max content with within.
	 * Therfore the following feature had been intruduced which helps in most of those cases where you would use the "full" type.
	 *
	 * In order to ease the setting of custom content that extends outwards
	 * of the content width without having to use the "full" type you can use a named slot "background"
	 * this slot will be placed outside of the content wrapper and can therefore easily extend towards the outside of the screen
	 *
	 * <Section>
	 * 	<div slot="background">
	 * 		... background content ...
	 * 	</div>
	 *
	 * 	... content here ...
	 * </Section>
	 */

	type SectionType = 'normal' | 'slim' | 'full';
	export let type: SectionType = 'normal';

	/**
	 * Whether to use margin or padding between two sections. Use margin for section that don't have a specific background
	 * so that the margin can collapse. Use padding for sections that have a different background (color or image).
	 */
	type GapType = 'margin' | 'padding';
	export let gapType: GapType = 'margin';

	const hasBackground = !!$$slots.background;
</script>

<section class={`${type} ${$$props.class} ${gapType}`}>
	<div class="inner-section">
		<slot />
	</div>
	{#if hasBackground}
		<div class="background">
			<slot name="background" />
		</div>
	{/if}
</section>

<style lang="scss">
	.background {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		z-index: -1;
		overflow: hidden;
	}

	section {
		width: 100%;
		position: relative;

		> .inner-section {
			width: 100%;
			height: 100%;
			margin: 0 auto;
			box-sizing: border-box;
		}

		&.normal {
			padding-inline-start: v(page-padding);
			padding-inline-end: v(page-padding);

			> .inner-section {
				max-width: v(max-width);
			}
		}

		&.slim {
			padding-inline-start: v(page-padding);
			padding-inline-end: v(page-padding);

			> .inner-section {
				max-width: v(max-width-slim);
			}
		}

		&.padding {
			padding-top: v(section-padding);
			padding-bottom: v(section-padding);
		}

		&.margin {
			margin-top: v(section-padding);
			margin-bottom: v(section-padding);
		}

		&.full {
			.inner-section {
				// max-width: 100%;
				// display: flex;
				flex-direction: column;
				align-items: center;
			}
		}

		@include media(phone) {
			&:not(.full) {
				/*
				.inner-section {
					padding: v(page-padding);
				}
				*/
			}
		}
	}
</style>
